/**
 * Kalkulationslogik – Mappen (Medaillenetui)
 *
 * WICHTIG: Diese Datei ist die EINZIGE Quelle der Preislogik für diesen Boxtyp.
 * Sie wird unverändert sowohl im Theme (Browser, für die Live-Vorschau) als auch
 * im Backend (PHP, für die verbindliche Preisberechnung beim Bestellen)
 * eingesetzt. Nach einer Änderung an dieser Datei IMMER auch
 * backend-php/private/lib/calculators/mappen.php von Hand nachziehen (siehe
 * Kommentar dort) – das Sync-Skript kopiert nur die JS-Variante.
 *
 * Deutlich einfacher als Stülpdeckelbox/Klappbox: KEINE Bogennutzen-
 * Berechnung (kein floorFit, keine Materialbögen) – stattdessen ein reiner
 * Preistabellen-Lookup nach Kundenvorlage (Stand 30.07.2026, Datei
 * "Mappen.xlsx"):
 *
 *   Ausführung: Medaillenetui, 2mm Buchbinderkarton mit Kunstlederpapier
 *   bezogen (7 Farben), 3 feste Formate:
 *     Mappe für A3 – 440×317mm
 *     Mappe für A4 – 230×317mm
 *     Mappe für A5 – 230×168mm
 *
 *   Je Format ein gestaffelter Stückpreis nach Menge (5 Staffeln):
 *     1–5 / 6–10 / 11–25 / 26–50 / 51–100 Stück
 *
 *   Optionale Aufpreise (ebenfalls nach denselben 5 Mengenstaffeln gestaffelt):
 *     - Heißfolienprägung (1c, matt oder glanz, 7 Farben) + einmalige
 *       Klischeekosten (lt. Kundenvorlage "ca. 70 €", siehe Punkt 2 unten)
 *     - Eckenausführung: Satinband (4x) ODER Buchecken aus Metall
 *       (vernickelt oder vermessingt, gleicher Preis) – schließen sich aus
 *
 * ACHTUNG – offene Punkte, mit Tobi/Kunde noch zu klären:
 *   1. Kein zusätzlicher Einrichtungspauschale (100 €) wie bei den anderen
 *      beiden Konfiguratoren: Die Kundentabelle liefert bereits fertige,
 *      alles-inklusive Stückpreise, keine Rohmaterial-/Bogen-Kalkulation zum
 *      Aufbauen – daher wurde hier NICHTS zusätzlich addiert.
 *   2. Klischeekosten für die Heißfolienprägung sind in der Vorlage nur als
 *      "ca. 70 €" angegeben (kein exakter Wert) – wird hier als einmalige
 *      Pauschale über die Stückzahl verteilt (wie EMBOSSING_SETUP bei den
 *      anderen Konfiguratoren). Bitte mit dem Kunden auf einen verbindlichen
 *      Wert festlegen.
 *   3. Für Bestellungen über 100 Stück liegt keine eigene Preisstaffel vor –
 *      es wird vorläufig der günstigste bekannte Preis (Staffel 51–100)
 *      weiterverwendet (gleiches Vorgehen wie bei den anderen Konfiguratoren
 *      für Mengen über der höchsten angegebenen Staffel).
 *   4. "Optionen auf Anfrage" (Kordel, Ziernaht, Band, Innen gleicher Bezug
 *      wie außen, Softcover aus 350g) sind NICHT einzeln auswählbar/bepreist,
 *      sondern nur als Hinweistext unter "Sonderwünsche" hinterlegt – analog
 *      zu den Express-Hinweisen bei den anderen Konfiguratoren.
 *
 * Vertrag:
 *   calculate(inputs) -> Ergebnisobjekt mit { valid, note, ...Detailfeldern }
 *   inputs = {
 *     format: 'a3' | 'a4' | 'a5',                  // immer Pflicht
 *     bezugFarbe: string, z. B. 'Schwarz',          // immer Pflicht
 *     qty: number (Stück, ganzzahlig, >= 1),
 *
 *     praegung: boolean,                            // Heißfolienprägung Ja/Nein
 *     praegungAusfuehrung: 'matt' | 'glanz' | '',    // nur wenn praegung === true
 *     praegungFarbe: string, z. B. 'Gold'            // nur wenn praegung === true
 *
 *     ecken: 'keine' | 'satinband' | 'metall_vernickelt' | 'metall_vermessingt'
 *   }
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.BoxCalculators = root.BoxCalculators || {};
    root.BoxCalculators.mappen = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // -- Feste Formate mit gestaffelten Stückpreisen (Reihenfolge = Reihenfolge
  //    der Mengenstaffeln in QTY_TIERS). --
  var FORMAT_OPTIONS = {
    a3: { name: 'Mappe für A3', dimensions: '440 × 317 mm', prices: [30, 23.5, 19.8, 18.9, 18] },
    a4: { name: 'Mappe für A4', dimensions: '230 × 317 mm', prices: [25, 19, 15.8, 14.8, 13] },
    a5: { name: 'Mappe für A5', dimensions: '230 × 168 mm', prices: [23, 16.5, 12.8, 11.5, 10.6] }
  };
  var DEFAULT_FORMAT = 'a4';

  // -- Bezugsfarben (Kunstlederpapier auf 2mm Buchbinderkarton) – reine
  //    Auswahl ohne Preisaufschlag. --
  var BEZUG_FARBEN = ['Schwarz', 'Dunkelblau', 'Blau', 'Weinrot', 'Rot', 'Grün', 'Weiß'];
  var DEFAULT_BEZUG_FARBE = 'Schwarz';

  // -- Mengenstaffeln: bestimmen, welcher Preis (Index) aus den obigen/
  //    unteren Preis-Arrays greift. Für Mengen > 100 wird die letzte Staffel
  //    (51–100) weiterverwendet (siehe Datei-Kopf Punkt 3). --
  var QTY_TIERS = [
    { max: 5, label: '1–5' },
    { max: 10, label: '6–10' },
    { max: 25, label: '11–25' },
    { max: 50, label: '26–50' },
    { max: 100, label: '51–100' }
  ];

  function getTierIndex(qty) {
    for (var i = 0; i < QTY_TIERS.length; i++) {
      if (qty <= QTY_TIERS[i].max) return i;
    }
    return QTY_TIERS.length - 1;
  }

  // -- Heißfolienprägung: gestaffelter Aufpreis pro Stück + einmalige
  //    Klischeekosten (ca., siehe Datei-Kopf Punkt 2). --
  var PRAEGUNG_SURCHARGE = [1.10, 0.95, 0.80, 0.70, 0.50];
  var PRAEGUNG_KLISCHEE_FEE = 70; // ca. – Platzhalter, siehe Datei-Kopf Punkt 2.
  var PRAEGUNG_FARBEN = ['Gold', 'Silber', 'Kupfer', 'Rot', 'Blau', 'Grün', 'Schwarz'];
  var PRAEGUNG_AUSFUEHRUNGEN = { matt: 'matt', glanz: 'glanz' };

  // -- Eckenausführung: schließt sich gegenseitig aus (Satinband ODER Metall). --
  var ECKEN_OPTIONS = {
    keine: { name: 'Keine', prices: [0, 0, 0, 0, 0] },
    satinband: { name: 'Ecken aus Satinband (4x)', prices: [2.4, 2.3, 2.1, 2.0, 1.9] },
    metall_vernickelt: { name: 'Buchecken aus Metall, vernickelt', prices: [1.6, 1.5, 1.4, 1.4, 1.4] },
    metall_vermessingt: { name: 'Buchecken aus Metall, vermessingt', prices: [1.6, 1.5, 1.4, 1.4, 1.4] }
  };
  var DEFAULT_ECKEN = 'keine';

  // Deutsche Mehrwertsteuer, nur für die Anzeige (netto/brutto) relevant –
  // alle übrigen Preise in dieser Datei sind Netto-Preise.
  var VAT_RATE = 0.19;

  function round2(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  function calculate(inputs) {
    inputs = inputs || {};

    var qty = Math.max(parseInt(inputs.qty || 1, 10) || 1, 1);

    var formatKey = FORMAT_OPTIONS.hasOwnProperty(inputs.format) ? inputs.format : DEFAULT_FORMAT;
    var format = FORMAT_OPTIONS[formatKey];

    var bezugFarbe = (inputs.bezugFarbe || '').trim() || DEFAULT_BEZUG_FARBE;

    var praegung = Boolean(inputs.praegung);
    var praegungAusfuehrung = inputs.praegungAusfuehrung || '';
    var praegungFarbe = (inputs.praegungFarbe || '').trim();

    var eckenKey = ECKEN_OPTIONS.hasOwnProperty(inputs.ecken) ? inputs.ecken : DEFAULT_ECKEN;
    var ecken = ECKEN_OPTIONS[eckenKey];

    var result = {
      valid: false,
      note: 'Bitte geben Sie Ihre Stückzahl ein, um eine Orientierungskalkulation zu erhalten.'
    };

    if (!qty) {
      return result;
    }

    if (praegung && (!PRAEGUNG_AUSFUEHRUNGEN.hasOwnProperty(praegungAusfuehrung) || !praegungFarbe)) {
      result.note = 'Bitte wählen Sie für die Heißfolienprägung eine Ausführung (matt/glanz) und eine Farbe aus.';
      return result;
    }

    var tierIndex = getTierIndex(qty);
    var qtyOverMaxTier = qty > QTY_TIERS[QTY_TIERS.length - 1].max;

    var basePricePerPiece = format.prices[tierIndex];
    var eckenPricePerPiece = ecken.prices[tierIndex];

    var praegungSurchargePerPiece = praegung ? PRAEGUNG_SURCHARGE[tierIndex] : 0;
    var praegungKlischeePerPiece = praegung ? (PRAEGUNG_KLISCHEE_FEE / qty) : 0;

    var totalPerPiece =
      basePricePerPiece +
      eckenPricePerPiece +
      praegungSurchargePerPiece +
      praegungKlischeePerPiece;

    var total = totalPerPiece * qty;

    // WICHTIG (Rundungskonsistenz Checkout, wie bei den anderen Konfiguratoren):
    // "total" ist der ungerundete Rohwert (nur zur Anzeige). "totalRounded"
    // ist der EINMALIG gerundete Gesamtpreis und genau der Betrag, der im
    // Backend als Draft-Order-Zeilenpreis an Shopify übergeben wird
    // (quantity 1, price totalRounded – siehe draft-order.php).
    var totalRounded = round2(total);

    var totalPerPieceVat = totalPerPiece * VAT_RATE;
    var totalPerPieceGross = totalPerPiece + totalPerPieceVat;
    var totalVat = total * VAT_RATE;
    var totalGross = total + totalVat;

    var note = 'Alle Preise sind Richtpreise auf Basis Ihrer Angaben.';
    if (qtyOverMaxTier) {
      note += ' Hinweis: Für Mengen über 100 Stück wird vorläufig der Preis der Staffel 51–100 verwendet – bitte sprechen Sie uns für ein individuelles Angebot an.';
    }

    return {
      valid: true,
      note: note,

      format: formatKey,
      formatName: format.name,
      formatDimensions: format.dimensions,
      bezugFarbe: bezugFarbe,
      qty: qty,

      tierIndex: tierIndex,
      tierLabel: QTY_TIERS[tierIndex].label,
      qtyOverMaxTier: qtyOverMaxTier,

      praegung: praegung,
      praegungAusfuehrung: praegung ? praegungAusfuehrung : '',
      praegungFarbe: praegung ? praegungFarbe : '',

      ecken: eckenKey,
      eckenName: ecken.name,

      basePricePerPiece: basePricePerPiece,
      eckenPricePerPiece: eckenPricePerPiece,
      praegungSurchargePerPiece: praegungSurchargePerPiece,
      praegungKlischeePerPiece: praegungKlischeePerPiece,

      totalPerPiece: totalPerPiece,
      total: total,
      totalRounded: totalRounded,

      vatRate: VAT_RATE,
      totalPerPieceVat: totalPerPieceVat,
      totalPerPieceGross: totalPerPieceGross,
      totalVat: totalVat,
      totalGross: totalGross
    };
  }

  /**
   * Liefert die Konfiguration als flache Liste von Label/Wert-Paaren, wie sie
   * als Line-Item-Properties auf der Shopify-Bestellung erscheinen sollen.
   *
   * Sichtbarkeit: Property-Namen, die mit einem Unterstrich ("_") beginnen,
   * werden von Shopify automatisch als "hidden properties" behandelt – sie
   * erscheinen NICHT im Warenkorb, Checkout, in der Bestellbestätigungs-Mail
   * oder im Kundenkonto, sind aber ganz normal auf der Bestellung im Shopify
   * Admin sichtbar (siehe auch stuelpdeckelbox.js/klappbox.js).
   */
  function describe(calc, extra) {
    if (!calc || !calc.valid) return {};

    var props = {
      'Format': calc.formatName + ' (' + calc.formatDimensions + ')',
      'Farbe (Bezug)': calc.bezugFarbe,
      'Stückzahl': calc.qty + ' Stück',
      'Heißfolienprägung': calc.praegung
        ? ('Ja, ' + calc.praegungAusfuehrung + ', ' + calc.praegungFarbe)
        : 'Nein'
    };

    if (calc.ecken !== 'keine') {
      props['Eckenausführung'] = calc.eckenName;
    }

    // -- Ab hier: rein interne/technische Angaben, nur für Admin/Produktion
    //    (Property-Name beginnt bewusst mit "_"). --
    props['_Mengenstaffel'] = calc.tierLabel + ' Stück';
    props['_Preis pro Stück (netto, rechnerisch)'] = calc.totalPerPiece.toFixed(2).replace('.', ',') + ' €';

    if (calc.praegung) {
      props['_Klischeekosten Heißfolienprägung (ca., einmalig)'] = PRAEGUNG_KLISCHEE_FEE.toFixed(2).replace('.', ',') + ' €';
    }

    props['_MwSt. (' + Math.round(calc.vatRate * 100) + ' %) pro Stück'] = calc.totalPerPieceVat.toFixed(2).replace('.', ',') + ' €';
    props['_Preis pro Stück (brutto)'] = calc.totalPerPieceGross.toFixed(2).replace('.', ',') + ' €';

    // Der verbindliche Gesamtpreis bleibt für den Kunden sichtbar (kein "_").
    props['Gesamtpreis (netto, verbindlich)'] = calc.totalRounded.toFixed(2).replace('.', ',') + ' €';

    if (extra && extra.notes) {
      props['Sonderwünsche'] = extra.notes;
    }

    return props;
  }

  return {
    calculate: calculate,
    describe: describe,
    materials: {
      FORMAT_OPTIONS: FORMAT_OPTIONS,
      BEZUG_FARBEN: BEZUG_FARBEN,
      PRAEGUNG_FARBEN: PRAEGUNG_FARBEN,
      ECKEN_OPTIONS: ECKEN_OPTIONS
    },
    QTY_TIERS: QTY_TIERS,
    VAT_RATE: VAT_RATE
  };
});
